// @ts-nocheck

import { basketCheckFreebets } from '../actions/basket';
import { doPullBasket } from '../actions/messages';
import { storageBasketSave } from '../actions/storage';
import { basketResetBoomActives } from '../modules/boom/actions/basket';
import { resetKLEligibleCollectibles } from '../modules/koh-lanta/actions/basket';
import { resetAllMPActives } from '../modules/monopoly/actions/basket';
import { type StateType } from '../states';
import { BasketActionTypes } from '../types/actions/basket';
import { MyMatchActionTypes } from '../types/actions/mymatch';

type StoreType = {
  dispatch: (action: unknown) => void;
  getState: () => StateType;
};

const handledActionTypes = [
  BasketActionTypes.ADD_ITEM,
  BasketActionTypes.DEL_ITEM,
  BasketActionTypes.ADD_BETBUILDER_ITEM,
  BasketActionTypes.SWITCH_MODE,
  BasketActionTypes.CLEAR,
  MyMatchActionTypes.MERGE,
  MyMatchActionTypes.SPLIT,
  MyMatchActionTypes.INJECT_TOP_MY_MATCH_INTO_BASKET,
];

const itemsMiddleware =
  ({ dispatch }: StoreType) =>
  (next: (action: unknown) => void) =>
  (action: unknown) => {
    const { type: actionType } = action;
    // next middleware + reducer stacks must be called before to dispatch next actions after reducer update

    if (handledActionTypes.indexOf(actionType) !== -1) {
      if (
        actionType === BasketActionTypes.ADD_ITEM ||
        actionType === BasketActionTypes.DEL_ITEM ||
        actionType === BasketActionTypes.ADD_BETBUILDER_ITEM ||
        actionType === MyMatchActionTypes.MERGE ||
        actionType === MyMatchActionTypes.SPLIT ||
        actionType === MyMatchActionTypes.INJECT_TOP_MY_MATCH_INTO_BASKET
      ) {
        const nextCall = next(action);

        dispatch(doPullBasket());
        dispatch(basketCheckFreebets());
        dispatch(storageBasketSave);
        dispatch(resetKLEligibleCollectibles());

        return nextCall;
      }

      if (actionType === BasketActionTypes.SWITCH_MODE) {
        const nextCall = next(action);

        dispatch(basketCheckFreebets());
        dispatch(storageBasketSave);

        return nextCall;
      }

      if (actionType === BasketActionTypes.CLEAR) {
        const nextCall = next(action);

        dispatch(resetAllMPActives());
        dispatch(basketResetBoomActives());
        dispatch(doPullBasket());
        dispatch(storageBasketSave);

        return nextCall;
      }
    }

    return next(action);
  };

export default itemsMiddleware;
